// src/app/services/token.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AppConfig} from "../app.config";
import {HelpersService} from "./helpers.service";

export interface Token {
  tokenId: string;
  name: string;
  partnerParentId: string;
  parent: string;
  isRevoked: boolean;
  createdDate: "2025-01-31T09:16:15.36",
  expiry: Date;
  tokenValue?: string; // Sensitive data, only visible in View Token modal
}

// "tokenId": 4,
//   "partnerParentId": 2,
//   "parent": null,
//   "name": "Token 3",
//   "createdBy": 5332274,
//   "createdDate": "2025-01-31T09:16:15.36",
//   "revokedBy": null,
//   "revokedDate": null,
//   "isRevoked": false,
//   "expiry": "2025-02-28T23:59:59",
//   "salt": "c496d55c-fa7e-49dc-8f18-34ebe9ffc052"

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private env: any;
  private apiUrl = '';

  constructor(private http: HttpClient,
              private appConfig: AppConfig,
              private helpersService: HelpersService, )
{
    this.env = this.appConfig.getEnvironmentNew();
    this.apiUrl = this.env.url
  }

  getTokens(partnerId: string): Observable<Token[]> {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.get<Token[]>(`${this.apiUrl}/FranchiseTokens/${partnerId}?code=${this.env.key}`, headers);
  }

  createToken(partnerId: string, Name: string,Expiry: string ): Observable<Token> {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.post<Token>(
      `${this.apiUrl}/FranchiseTokens/${partnerId}/Create?code=${this.env.key}`,
      { Name: Name, Expiry: Expiry},
      headers,
    );
  }

  revokeToken(partnerId: string, tokenId : string): Observable<void> {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.post<void>(
      `${this.apiUrl}/FranchiseTokens/${partnerId}/Revoke/${tokenId}?code=${this.env.key}`,
      { TokenId: tokenId },
      headers,
    );
  }

  viewTokens(partnerId: string, tokenId): Observable<Token> {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get<Token>(`${this.apiUrl}/FranchiseTokens/${partnerId}/AuthToken/${tokenId}?code=${this.env.key}`, headers);
  }
}
